export default function fixDate(date?: Date): string | null {
    if (!date) {
        return null;
    }

    if (typeof(date) === "string"){
        date = new Date(date);
    }

    return `${date.getFullYear()}-${("0" +(date.getMonth()+1)).slice(-2)}-${("0" + date.getDate()).slice(-2)}T00:00:00.000Z`;
}